'use client';

import { useQuery } from '@tanstack/react-query';

import { useSupabase } from '@kit/supabase/hooks/use-supabase';

export function useSession() {
  const client = useSupabase();

  return useQuery({
    queryKey: ['auth', 'session'],
    queryFn: async () => {
      const { data, error } = await client.auth.getSession();

      if (error) {
        throw error;
      }

      return data.session;
    },
    staleTime: 5 * 60 * 1000,
  });
}
